import React from 'react';
import Proptypes from 'prop-types';
import withMediaQuery from 'components/WithMediaQuery';
import { withStyles } from "tss-react/mui";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTransition from 'components/DialogTransition';
import ResponsiveDialogHeader from 'components/ResponsiveDialogHeader';
import classNames from 'classnames';
import styles from './styles';
import DialogActions from '@mui/material/DialogActions';
import PrimaryDialogButton from 'components/PrimaryDialogButton';
import SecondaryDialogButton from 'components/SecondaryDialogButton';
import List from '@mui/material/List';
import { Subtitle2, Body2 } from 'components/Typography';
import { ListItem, ListItemText } from '@mui/material';

class SiteSelectionDialog extends React.Component {

    handleClose = () => {
        this.props.handleClose();
    };

    render() {
        const { classes, fullScreen } = this.props;

        return (

            <Dialog
                fullScreen={fullScreen}
                onClose={this.props.handleClose}
                TransitionComponent={DialogTransition}
                open={this.props.open}
                className={classNames(classes.dialogRoot, this.props.open ? classes.dialog : '')}>

                <ResponsiveDialogHeader
                    fullScreen={fullScreen}
                    title={this.props.title}
                    handleClose={this.props.handleClose}
                    showBackIcon={false} />

                <DialogContent style={{minWidth: 600} }>
                    {this.props.open &&
                        <div className={classes.panel}>

                            <div className={classes.wrapper}>
                                <Subtitle2>{this.props.siteName}</Subtitle2>
                                <Body2>{this.props.site.name}</Body2>
                            </div>

                            <div className={classes.wrapper}>
                                <Subtitle2>{this.props.siteName} Code</Subtitle2>
                                <Body2>{this.props.site.siteCode}</Body2>
                            </div>

                            <div className={classes.wrapper}>
                                <Subtitle2>CIC</Subtitle2>
                                <Body2>{this.props.project.contractorInCharge}</Body2>
                            </div>

                            <div className={classes.wrapper}>
                                <Subtitle2>{this.props.projectName}</Subtitle2>
                                <Body2>{this.props.project.name}</Body2>
                            </div>

                            <div className={classes.wrapper}>
                                <Subtitle2>{this.props.divisionName}</Subtitle2>
                                <Body2>{this.props.project.divisionName}</Body2>
                            </div>

                            <div className={classes.wrapper}>
                                <Subtitle2>Address</Subtitle2>
                                <Body2>{this.props.site.address}</Body2>
                            </div>

                            <div className={classes.buttonPanel}>
                                <PrimaryDialogButton className={classes.button} onClick={() => this.props.onSiteSelected(this.props.site)}>
                                    Select {this.props.siteName}
                                </PrimaryDialogButton>
                            </div>


                            {this.props.zones != null &&
                                <List>
                                    <Subtitle2>{this.props.zoneName}</Subtitle2>
                                    {this.props?.zones.map((item, index) =>
                                        <ListItem key={index} style={{ padding: '8px 0' } }>
                                            <ListItemText primary={item.name} />
                                            <SecondaryDialogButton style={{margin:0}} className={classes.button} onClick={() => this.props.onZoneSelected(this.props.site, item)}>
                                                Select {this.props.zoneName}
                                            </SecondaryDialogButton>
                                        </ListItem>
                                    )}
                                </List>
                            }

                        </div>
                    }
                </DialogContent>
                <DialogActions>
                    <SecondaryDialogButton onClick={this.props.handleClose}>
                        Cancel
                    </SecondaryDialogButton>


                </DialogActions>
            </Dialog>
        );
    }
}

SiteSelectionDialog.propTypes = {
    handleClose: Proptypes.func.isRequired,
    open: Proptypes.bool.isRequired,
    title: Proptypes.string.isRequired,
    onSiteSelected: Proptypes.func.isRequired,
    onZoneSelected: Proptypes.func.isRequired

};

const Media = withMediaQuery(theme => theme.breakpoints.down('lg'))(SiteSelectionDialog);
const Styled = withStyles(Media, styles);

export default Styled;